function initShopTheLook(scope = document) {
  var mySwiper1 = new Swiper(".shop-the-look__track", {
    spaceBetween: 12,
    slidesPerView: 1.24,
    centeredSlides: true,
    loop: true,
    // ✅ keyboard initially OFF
    simulateTouch: true,
    allowTouchMove: true,
    grabCursor: true, 
    keyboard: {
      enabled: true,
      onlyInViewport: true,
      pageUpDown: true,
    },
    navigation: {
      nextEl: ".btn-next",
      prevEl: ".btn-prev"
    },
    pagination: {
        el: '.shop-the-look__scrollbar-thumb',
        clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false
      },
      1445: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false
      }
    }
  });
}

/* function initShopTheLook(scope = document) {
  const components = scope.querySelectorAll('.shop-the-look');

  components.forEach(component => {
    if (component.dataset.initialized === 'true') return;
    component.dataset.initialized = 'true';

    const slider = component.querySelector('.shop-the-look__slider');
    const track = component.querySelector('.shop-the-look__track');
    const btnPrev = component.querySelector('.btn-prev');
    const btnNext = component.querySelector('.btn-next');
    const thumb = component.querySelector('.shop-the-look__scrollbar-thumb');

    let slides = Array.from(component.querySelectorAll('.shop-the-look__slide'));
    if (!slider || !track || slides.length === 0) return;

    const slideCount = slides.length;
    
    slides.forEach(slide => {
      const cloneStart = slide.cloneNode(true);
      const cloneEnd = slide.cloneNode(true);

      cloneStart.classList.add('clone');
      cloneEnd.classList.add('clone');

      track.appendChild(cloneStart);
      track.insertBefore(cloneEnd, track.firstChild);
    });

    slides = Array.from(component.querySelectorAll('.shop-the-look__slide'));

    const gap = parseInt(getComputedStyle(track).gap) || 20;

    function getSlideWidth() {
      return slides[0].offsetWidth + gap;
    }
    
    function goToIndex(index, smooth = true) {
      const slideWidth = getSlideWidth();
      const offset = (slider.clientWidth - slides[0].offsetWidth) / 2;

      slider.scrollTo({
        left: (index * slideWidth) - offset,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    let currentIndex = slideCount;
    
    function checkLoop() {
      const slideWidth = getSlideWidth();
      const maxIndex = slides.length - slideCount;

      if (currentIndex <= 0) {
        currentIndex = slideCount;
        goToIndex(currentIndex, false);
      }

      if (currentIndex >= maxIndex) {
        currentIndex = slideCount;
        goToIndex(currentIndex, false);
      }
    }

    function next() {
      currentIndex++;
      goToIndex(currentIndex);
    }

    function prev() {
      currentIndex--;
      goToIndex(currentIndex);
    }
    
    function updateScrollbar() {
      if (!thumb) return;

      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      if (maxScrollLeft <= 0) return;

      const scrollPercentage = slider.scrollLeft / maxScrollLeft;
      const thumbWidthPercent = Math.max(
        15,
        (slider.clientWidth / slider.scrollWidth) * 100
      );

      thumb.style.width = `${thumbWidthPercent}%`;

      const trackWidth = thumb.parentElement.offsetWidth;
      const thumbWidth = (thumbWidthPercent / 100) * trackWidth;
      const maxMove = trackWidth - thumbWidth;

      thumb.style.transform = `translateX(${maxMove * scrollPercentage}px)`;
    }
    
    btnNext?.addEventListener('click', next);
    btnPrev?.addEventListener('click', prev);

    slider.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        updateScrollbar();
        checkLoop();
      });
    });

    window.addEventListener('resize', () => {
      goToIndex(currentIndex, false);
      updateScrollbar();
    });
    
    setTimeout(() => {
      goToIndex(currentIndex, false);
      updateScrollbar();
    }, 50);
    
    component.querySelectorAll('.shop-the-look__hotspot-popup').forEach(popup => {
      const hotspot = popup.closest('.shop-the-look__hotspot');

      const updatePos = () => {
        popup.classList.remove('left-align', 'right-align');

        const rect = popup.getBoundingClientRect();

        if (rect.left < 20) {
          popup.classList.add('left-align');
        } else if (rect.right > window.innerWidth - 20) {
          popup.classList.add('right-align');
        }
      };

      hotspot?.addEventListener('mouseenter', updatePos);
      hotspot?.addEventListener('touchstart', updatePos, { passive: true });
    });
  });
} */

document.addEventListener('DOMContentLoaded', () => {
  initShopTheLook();
});

document.addEventListener('shopify:section:load', (e) => {
  initShopTheLook(e.target);
});